import {
  ConstrainedObject,
  ConstraintScope,
  GroupedSelectedElement,
  SelectedElement,
  SelectedItem,
} from '@Models';
import { allConstrainableChildByScope } from '@Selectors/builder/myArmyList/common/constraints/elements/constrainable/all-constrainable-child-by-scope';

export const selectedElementByScope = (
  elements: ConstrainedObject[],
  selectedElements: SelectedElement[],
  selectedElement: SelectedElement,
  scope: ConstraintScope,
): SelectedElement[] => {
  const constrainedObject = elements.find(
    (i) =>
      i.type === selectedElement.constrained.type &&
      i.id === selectedElement.constrained.id,
  );
  if (!constrainedObject) return [];

  const scopedElements = allConstrainableChildByScope(
    elements,
    constrainedObject,
    scope,
  );

  return selectedElements
    .filter((item) =>
      scopedElements.some(
        (scopedElement) =>
          item.constrained.id === scopedElement.id &&
          item.constrained.type === scopedElement.type,
      ),
    )
    .filter(
      (item) =>
        scope !== ConstraintScope.Parent ||
        (scope === ConstraintScope.Parent &&
          item.parents.some((p) =>
            selectedElement.parents.some(
              (parent) => parent.id === p.id && parent.type === p.type,
            ),
          )),
    );
};

export const groupedSelectedElementByScope = (
  elements: ConstrainedObject[],
  selectedElements: SelectedElement[],
  selectedElement: SelectedElement,
  scope: ConstraintScope,
): GroupedSelectedElement[] => {
  const scopedSelectedElements = selectedElementByScope(
    elements,
    selectedElements,
    selectedElement,
    scope,
  );

  return scopedSelectedElements
    .filter(
      (item) =>
        item.constrained.id === selectedElement.constrained.id &&
        item.constrained.type === selectedElement.constrained.type,
    )
    .reduce((acc, element) => {
      const item = acc.find(
        (i) =>
          i.constrained.id === element.constrained.id &&
          i.constrained.type === element.constrained.type,
      );

      if (!item) {
        acc.push({
          parents: element.parents,

          constrained: element.constrained,

          items: [
            {
              id: element.id,
              type: element.type,
              name: element.name,
            } satisfies SelectedItem as SelectedItem,
          ],

          count: element.count,
          quantity: element.quantity,
          points: element.points,
        } satisfies GroupedSelectedElement as GroupedSelectedElement);
        return acc;
      }

      item.parents.push(
        ...element.parents.filter(
          (p) =>
            !item.parents.some((pa) => p.id === pa.id || p.type === pa.type),
        ),
      );
      item.items.push({
        id: element.id,
        type: element.type,
        name: element.name,
      } satisfies SelectedItem as SelectedItem);
      item.count += element.count;
      item.quantity += element.quantity;

      return acc;
    }, [] as GroupedSelectedElement[]);
};
